import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/* webpackChunkName: "home" */ './views/HomeAlternateZFoldZFlip.vue'),
    },
    // ALZA
    /*{
      path: '/alza/cashback',
      name: 'alza-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeZFoldZFlip.vue'),
    },*/
    // AQUA
    /*{
      path: '/aqua/cashback',
      name: 'aqua-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // AUCHAN
    /*{
      path: '/auchan/cashback',
      name: 'auchan-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // BEST BYTE
    /*{
      path: '/bestbyte/cashback',
      name: 'bestbyte-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // EMAG-EDIGITAL
    /*{
      path: '/emag/voucher',
      name: 'emag-edigital-voucher-home',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeZFoldZFlip.vue'),
    },*/
    // ESTORE
    /* {
      path: '/estore/voucher',
      name: 'estore-voucher-home',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import('./views/Home.vue'),
    }, */
    // ESTORE A52S
    /* {
      path: '/estore/voucher/a52s',
      name: 'estore-voucher-a52-home',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import('./views/HomeA52s.vue'),
    }, */
    // EURONICS
    /*{
      path: '/euronics/voucher',
      name: 'euronics-voucher-home',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeZFoldZFlip.vue'),
    },*/
    // FIRSTPHONE
    /*{
      path: '/firstphone/cashback',
      name: 'firstphone-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // IPON
    /*{
      path: '/ipon/cashback',
      name: 'ipon-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // KONZOLVILÁG
    /*{
      path: '/konzolvilag/cashback',
      name: 'konzolvilag-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // NOTEBOOK
    /*{
      path: '/notebookhu/cashback',
      name: 'notebookhu-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // SES
    /*{
      path: '/ses/voucher',
      name: 'ses-voucher-home',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // SPEEDSHOP
    /*{
      path: '/speedshop/cashback',
      name: 'speedshop-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // TELEKOM
    /*{
      path: '/telekom/cashback',
      name: 'telekom-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeZFoldZFlip.vue'),
    },*/
    // TELEKOM
    /*{
      path: '/telekom/cashback',
      name: 'telekom-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // YETTEL
    /*{
      path: '/yettel/cashback',
      name: 'yettel-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import(/!* webpackChunkName: "home" *!/ './views/HomeA33.vue'),
    },*/
    // VODAFONE
    /*{
      path: '/vodafone/cashback',
      name: 'vodafone-cashback-home',
      meta: { layout: 'outer', bbType: 'cashback' },
      component: () => import('./views/HomeA33.vue'),
    },*/
    {
      path: '/hogyan-mukodik',
      name: 'hogyan-mukodik',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/GeneralInformationsPage.vue'),
    },
    {
      path: '/rolunk',
      name: 'rolunk',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/AboutUs.vue'),
    },
    {
      path: '/gyik',
      name: 'gyik',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/FaqPage.vue'),
    },
    {
      path: '/termek-adatok/:productName',
      name: 'termek-adatok',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/ProductPage.vue'),
    },
    {
      path: '/voucher/szemelyes-adatok',
      name: 'voucher-szemelyes-adatok',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import(/* webpackChunkName: "base" */ './views/CustomerPage.vue'),
    },
    // ESTORE A52S
    /*{
      path: '/szemelyes-adatok',
      name: 'estore-voucher-a52-szemelyes-adatok',
      meta: { layout: 'outer', bbType: 'voucher' },
      component: () => import('./views/CustomerPage.vue'),
    },*/
    {
      path: '/cashback/szemelyes-adatok',
      name: 'cashback-szemelyes-adatok',
      meta: { layout: 'outer', bbType: 'cashback', docReq: 1 },
      component: () => import(/* webpackChunkName: "base" */ './views/CustomerPage.vue'),
    },
    {
      path: '/szallitasi-adatok/:identicalHash',
      name: 'szallitasi-adatok',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/ShippingPage.vue'),
    },
    {
      path: '/szallitasi-adatok',
      name: 'szallitasi-adatok-not-valid',
      redirect: {name: 'home' },
    },
    {
      path: '/arajanlat-elfogadasa/:identicalHash',
      name: 'arajanlat-elfogadasa',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/OfferAcceptPage.vue'),
    },
    {
      path: '/arajanlat-elfogadasa',
      name: 'arajanlat-elfogadasa-not-valid',
      redirect: {name: 'home' },
    },
    {
      path: '/arajanlat-elutasitasa/:identicalHash',
      name: 'arajanlat-elutasitasa',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/OfferRejectPage.vue'),
    },
    {
      path: '/arajanlat-elutasitasa',
      name: 'arajanlat-elutasitasa-not-valid',
      redirect: {name: 'home' },
    },
    {
      path: '*',
      meta: { layout: 'outer' },
      component: () => import(/* webpackChunkName: "base" */ './views/NoPage.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
     if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 64 } };
    }
    return { x: 0, y: 0 };
  },
});
